import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import * as bookingService from "../../services/booking.services";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { SWAL_SETTINGS, showFilterlist } from "../../../../utils/Constants";
import { formateDateWithMonth, formatSecondstoHHMMSS, handleServerValidations, TrimText } from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import SessionLogDetails from "./SessionLogDetails";

const BookingTable = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);

    const [statsupdate, setStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({ order: -1, column: "createdAt" });
    const [defaultSorting, setDefaultSorting] = useState(false);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: "Consultations", url: "" },
    ];
    const [resetdate, setResetDate] = useState(false);
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                bookingService
                    .List(formData)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        setList(data && data.data && data.data.list ? data.data.list : []);

                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        console.log("error ====> ", error);
                    });
            }
        }, 300);
        return () => clearTimeout(getData);
    }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

    const viewfunction = (row) => {
        navigate(`/admin/consultation/view/${row.id}`);
    };

    const ChangeStatus = (data, Num) => {
        let ids = Array.isArray(data) ? data : [data];
        const formData = new FormData();
        formData.append("o_id", JSON.stringify(ids));
        formData.append("status", Num);
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
        }).then((result) => {
            if (result.isConfirmed) {
                bookingService
                    .Status(formData)
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };

    function Deletefunction(data) {
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            text: t("you_not_be_able_to_revert_this"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes_delete"),
        }).then((result) => {
            if (result.isConfirmed) {
                const formdata = new FormData();
                let ids = Array.isArray(data) ? data : [data];
                formdata.append("o_id", JSON.stringify(ids));
                bookingService
                    .Delete(formdata)
                    .then((response) => {
                        setStatusUpdate(!statsupdate);
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("deleteError");
                    });
            }
        });
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };
    // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };
    // search or filer end

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
    };

    // To show notes modal
    const handleShowNotes = (row) => {
        setModalData(row);
        setShowNotesModal(true);
    };
    console.log("modalData", modalData);
    console.log("showNotesModal", showNotesModal);

    const generateFullNoteText = (row) => {
        return `
      User: ${row.user?.name}
      Astrologer: ${row.astrologer?.name}
      Service Type: ${row.service_type}
      Mode: ${row.mode_of_consultation}
      Duration: ${row.duration} sec (${row.charged_duration_in_minutes} min charged)
      Base Price/Min: ${row.currency === 'USD' ? '$' : '₹'}${row.base_price_per_minute}
      Astrologer Discount: ${row.astrologer_offer_percentage}%
      Platform Discount: ${row.platform_offer_percentage}%
      Total Amount: ${row.currency === 'USD' ? '$' : '₹'}${row.final_amount}
      Astrologer Earnings: ${row.currency === 'USD' ? '$' : '₹'}${row.astrologer_earning_amount}
      Platform Commission (%): ${row.platform_commission_percentage}%
      Platform Earnings: ${row.currency === 'USD' ? '$' : '₹'}${row.platform_commission_amount}
      Session Notes: ${row.session_notes}
      Created At: ${formateDateWithMonth(row.createdAt)}
      `;
    };
    // To close notes modal
    const handleCloseNotes = () => {
        setShowNotesModal(false);
        setModalData(null);
    };

    const handleDownloadNotes = (notes, userId) => {
        const element = document.createElement("a");
        const file = new Blob([notes], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        element.download = `session_notes_${userId || "unknown"}.txt`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* table section */}
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">Consultations</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => {
                                            prepareSearch("createdAt", e);
                                        }}
                                        resetdate={resetdate}
                                    />
                                </div> */}
                                {/* <div className="me-3">
                                    <StatusFilter
                                        data={showFilterlist}
                                        prepareSearch={prepareSearch}
                                    />
                                    </div> */}

                                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2">
                                    {t("btn_reset_filter")}
                                </button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th className="position-relative select_head">
                                            <span>{t("list_heading_sno")}</span>
                                        </th>
                                        <th><span>Order Number</span></th>
                                        <th><span>User Name</span></th>
                                        <th><span>Astrologer Name</span></th>
                                        <th><span>Booking Date</span></th>
                                        <th><span>Start Time</span></th>
                                        <th><span>End Time</span></th>
                                        <th><span>Duration</span></th>
                                        <th><span>Consultation Type</span></th>
                                        <th><span>Amount</span></th>
                                        <th><span>GST (%)</span></th>
                                        <th><span>GST Amount</span></th>
                                        <th><span>Currency</span></th>
                                        <th><span>Status</span></th>
                                        <th><span>Payment Status</span></th>
                                        <th><span>Payment Method</span></th>
                                        <th><span>Transaction ID</span></th>
                                        <th className="created_head">
                                            <div className="sorting_column">
                                                <span>{t("list_heading_created_date")}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="createdAt" />
                                            </div>
                                        </th>
                                        <th className="action_head">
                                            <span>{t("list_heading_action") || "Actions"}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader && datalength > 0 ? (
                                        <tr>
                                            <td colSpan={19}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {list.length ? (
                                                list.map((row, i) => (
                                                    <tr key={i}>
                                                        <td>{(page - 1) * itemperpage + i + 1}</td>
                                                        <td className="fw-bold text-primary">{row?.order_number || `ORD-CONS-${row?.id}`}</td>
                                                        <td><div className="d-flex">{row?.User?.name || row?.user?.name || "N/A"}</div></td>
                                                        <td><div className="d-flex">{row?.Astrologer?.name || row?.astrologer?.name || "N/A"}</div></td>
                                                        <td>{row?.booking_date ? formateDateWithMonth(row?.booking_date) : <span className="text-muted">Not Scheduled Yet</span>}</td>
                                                        <td>{row?.booking_start_time || "-"}</td>
                                                        <td>{row?.booking_end_time || "-"}</td>
                                                        <td>{row?.duration ? formatSecondstoHHMMSS(row.duration) : "N/A"}</td>
                                                        <td>{row?.consultation_type || "N/A"}</td>
                                                        <td>{row?.amount !== undefined && row?.amount !== null ? `${row?.currency === "USD" ? "$" : "₹"}${Number(row.amount).toFixed(2)}` : "N/A"}</td>
                                                        <td>{row?.gst_percent !== undefined && row?.gst_percent !== null ? `${row.gst_percent}%` : "0%"}</td>
                                                        <td>{row?.gst_amount !== undefined && row?.gst_amount !== null ? `${row?.currency === "USD" ? "$" : "₹"}${Number(row.gst_amount).toFixed(2)}` : "N/A"}</td>
                                                        <td>{row?.currency || "N/A"}</td>
                                                        <td>{row?.status || "N/A"}</td>
                                                        <td>{row?.payment_status || "N/A"}</td>
                                                        <td>{row?.payment_method || "N/A"}</td>
                                                        <td>{row?.transaction_id || "-"}</td>
                                                        <td>{row.created_at ? formateDateWithMonth(row.created_at) : row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <button
                                                                    className="btn ripple btn-main-primary signbtn"
                                                                    onClick={() => viewfunction(row)}
                                                                >
                                                                    <i className="fa fa-eye me-1"></i>
                                                                    {t("btn_view")}
                                                                </button>
                                                                <button
                                                                    className="btn ripple btn-main-primary signbtn"
                                                                    title="View Tax Invoice"
                                                                    onClick={() => {
                                                                        const bookingId = row.id || row._id;
                                                                        if (row.invoice_pdf) {
                                                                            window.open(row.invoice_pdf, "_blank");
                                                                        } else {
                                                                            bookingService.GetConsultationInvoice(bookingId).then((res) => {
                                                                                if (res && res.success && res.data?.invoice_url) {
                                                                                    window.open(res.data.invoice_url, "_blank");
                                                                                } else {
                                                                                    Swal.fire({
                                                                                        icon: "error",
                                                                                        text: (res && res.message) || "Failed to fetch invoice",
                                                                                        ...SWAL_SETTINGS,
                                                                                    });
                                                                                }
                                                                            }).catch((err) => {
                                                                                Swal.fire({
                                                                                    icon: "error",
                                                                                    text: (err && err.message) || "Failed to fetch invoice",
                                                                                    ...SWAL_SETTINGS,
                                                                                });
                                                                            });
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="fa fa-file-pdf-o me-1"></i> Invoice
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={19} className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="" id="example1_info" role="status" aria-live="polite">
                            <b>
                                {t("msg_total_records")} : {datalength ? datalength : "0"}
                            </b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={setPage}
                                pageRoute={[
                                    {
                                        name: "Consultation",
                                        path: "/admin/consultation/list",
                                    },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            {/* session notes modal */}
            {/* {showNotesModal && modalData && (
                <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "#0008", zIndex: 9999 }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Session Details</h5>
                                <button type="button" className="close" onClick={handleCloseNotes}>
                                    &times;
                                </button>
                            </div>
                            <div className="modal-body">
                                <b>User:</b> {modalData.user?.name}
                                <br />
                                <b>Astrologer:</b> {modalData.astrologer?.name}
                                <br />
                                <b>Service Type:</b> {modalData.service_type}
                                <br />
                                <b>Mode:</b> {modalData.mode_of_consultation}
                                <br />
                                <b>Duration:</b> {modalData.duration} sec ({modalData.charged_duration_in_minutes} min charged)
                                <br />
                                <b>Base Price/Min:</b> ₹{modalData.base_price_per_minute}
                                <br />
                                <b>Astrologer Discount:</b> {modalData.astrologer_offer_percentage}%<br />
                                <b>Platform Discount:</b> {modalData.platform_offer_percentage}%<br />
                                <b>Total Amount:</b> ₹{modalData.final_amount}
                                <br />
                                <b>Astrologer Earnings:</b> ₹{modalData.astrologer_earning_amount}
                                <br />
                                <b>Platform Commission (%):</b> {modalData.platform_commission_percentage}%<br />
                                <b>Platform Earnings:</b> ₹{modalData.platform_commission_amount}
                                <br />
                                <b>Session Notes:</b>
                                <pre>{modalData.session_notes}</pre>
                                <b>Created At:</b> {formateDateWithMonth(modalData.createdAt)}
                                <br />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => handleDownloadNotes(generateFullNoteText(modalData), modalData._id)}>
                                    Download
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={handleCloseNotes}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
            {/* {showNotesModal && modalData && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.5)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflowY: "auto"
    }}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: 8,
        width: "95%",
        maxWidth: 600,
        padding: 30,
        boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        position: "relative",
        margin: "20px auto"
      }}
    >
      <h5 style={{marginTop: 0, marginBottom: 20}}>Session Details</h5>
      <button
        style={{
          position: "absolute",
          top: 10,
          right: 16,
          background: "none",
          border: "none",
          fontSize: 24,
          cursor: "pointer",
          color: "#888"
        }}
        onClick={handleCloseNotes}
        aria-label="Close modal"
      >
        &times;
      </button>

      <div style={{marginBottom: 16, lineHeight: "1.8"}}>
        {modalData.user?.name && (
          <>
            <b>User:</b> {modalData.user.name} <br />
          </>
        )}
        {modalData.astrologer?.name && (
          <>
            <b>Astrologer:</b> {modalData.astrologer.name} <br />
          </>
        )}
        {modalData.service_type && (
          <>
            <b>Service Type:</b> {modalData.service_type.replace(/_/g, " ")} <br />
          </>
        )}
        {modalData.mode_of_consultation && (
          <>
            <b>Mode:</b> {modalData.mode_of_consultation} <br />
          </>
        )}
        {modalData.duration && (
          <>
            <b>Duration:</b> {formatSecondstoHHMMSS(modalData.duration)} ({modalData.charged_duration_in_minutes} min charged) <br />
          </>
        )}
        {modalData.base_price_per_minute !== null && modalData.base_price_per_minute !== undefined && (
          <>
            <b>Base Price/Min:</b> ₹{Number(modalData.base_price_per_minute).toFixed(2)} <br />
          </>
        )}
        {modalData.astrologer_offer_percentage !== null && modalData.astrologer_offer_percentage !== undefined && (
          <>
            <b>Astrologer Discount:</b> {modalData.astrologer_offer_percentage}% <br />
          </>
        )}
        {modalData.platform_offer_percentage !== null && modalData.platform_offer_percentage !== undefined && (
          <>
            <b>Platform Discount:</b> {modalData.platform_offer_percentage}% <br />
          </>
        )}
        {modalData.final_amount !== null && modalData.final_amount !== undefined && (
          <>
            <b>Total Amount:</b> ₹{Number(modalData.final_amount).toFixed(2)} <br />
          </>
        )}
        {modalData.astrologer_earning_amount !== null && modalData.astrologer_earning_amount !== undefined && (
          <>
            <b>Astrologer Earnings:</b> ₹{Number(modalData.astrologer_earning_amount).toFixed(2)} <br />
          </>
        )}
        {modalData.platform_commission_percentage !== null && modalData.platform_commission_percentage !== undefined && (
          <>
            <b>Platform Commission (%):</b> {Number(modalData.platform_commission_percentage).toFixed(2)}% <br />
          </>
        )}
        {modalData.platform_commission_amount !== null && modalData.platform_commission_amount !== undefined && (
          <>
            <b>Platform Earnings:</b> ₹{Number(modalData.platform_commission_amount).toFixed(2)} <br />
          </>
        )}
        {modalData.session_notes && modalData.session_notes.trim() !== "" && (
          <>
            <b>Session Notes:</b>
            <pre style={{whiteSpace: "pre-wrap", margin: "8px 0", background: "#f5f5f5", padding: "10px", borderRadius: 4, fontSize: 12}}>
              {modalData.session_notes}
            </pre>
          </>
        )}
        {modalData.createdAt && (
          <>
            <b>Created At:</b> {formateDateWithMonth(modalData.createdAt)} <br />
          </>
        )}
      </div>

      <div style={{display: "flex", gap: "10px"}}>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => handleDownloadNotesPDF(modalData)}
        >
          Download as PDF
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCloseNotes}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)} */}

{showNotesModal && modalData && (
<SessionLogDetails modalData={modalData} handleCloseNotes={handleCloseNotes} />
)}

        </>
    );
};

export default BookingTable;
